import {
  collection,
  doc,
  setDoc,
  deleteDoc,
  onSnapshot,
  serverTimestamp,
  type Unsubscribe,
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { useHabitStore } from '@/stores/habitStore';
import type { Habit } from '@/types';
import { toDate } from './firestoreDate';
import { logSyncError } from './syncErrors';

function habitsCol(uid: string) {
  return collection(db, 'users', uid, 'habits');
}

export function startHabitSync(uid: string): Unsubscribe {
  return onSnapshot(
    habitsCol(uid),
    (snap) => {
      const habits: Habit[] = snap.docs.map((d) => {
        const data = d.data();
        const habit: Habit = {
          id: d.id,
          name: data.name as string,
          icon: data.icon as string,
          color: data.color as string,
          frequency: data.frequency as Habit['frequency'],
          currentStreak: data.currentStreak as number,
          longestStreak: data.longestStreak as number,
          createdAt: toDate(data.createdAt),
          updatedAt: toDate(data.updatedAt),
        };

        if (data.description !== undefined) habit.description = data.description as string;
        if (data.customDays !== undefined) habit.customDays = data.customDays as number[];
        if (data.scheduledTime !== undefined) habit.scheduledTime = data.scheduledTime as string;
        if (data.durationMinutes !== undefined)
          habit.durationMinutes = data.durationMinutes as number;

        return habit;
      });
      useHabitStore.setState({ habits });
    },
    logSyncError('habitSync', uid),
  );
}

export async function writeHabit(uid: string, habit: Habit): Promise<void> {
  const { id, ...rest } = habit;
  await setDoc(doc(habitsCol(uid), id), { ...rest, serverUpdatedAt: serverTimestamp() });
}

export async function deleteHabit(uid: string, habitId: string): Promise<void> {
  await deleteDoc(doc(habitsCol(uid), habitId));
}
